import { render, staticRenderFns } from "./Bookingsuccess.vue?vue&type=template&id=f9f1ff9c"
import script from "./Bookingsuccess.vue?vue&type=script&lang=js"
export * from "./Bookingsuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports